import React from "react";
import "./Template2.css";

const Template5 = ({ hazardsPrecautions }) => {
  const boxStyle = {
    border: "1px solid gray",
    padding: "2px 6px",
    display: "inline-block",
    borderRadius: "4px",
    marginRight: "4px",
    // fontSize: "0.9em",
  };

  const tickStyle = {
    color: "green",
    fontWeight: "bold",
    marginLeft: "4px",
  };

  const parsedHazards =
    hazardsPrecautions.length > 0 && hazardsPrecautions[0].residual_hazards
      ? JSON.parse(hazardsPrecautions[0].residual_hazards)
      : [];

  const parsedPPE =
    hazardsPrecautions.length > 0 && hazardsPrecautions[0].ppe_precautions
      ? JSON.parse(hazardsPrecautions[0].ppe_precautions)
      : [];

  return (
    <>
      <div className="template-container">
        <div className="template-container-content1">
          <div className="template-container-pera">
            <div className="cold-remark">
              <div className="template-heading">टिप्पणियाँ / Remarks:</div>

              {/* HAZARDS */}
              <div>
                1.क्रिया में निम्नलिखित संभावित जोखिम हो सकते है (संभावित
                मुद्दों को चिह्नित करें) ऑक्सीजन की कमी एवं ज्वलनशील पदार्थ,
                पायरोफोरिक आयर्न संक्षारक रसायन पाया, संभावित अन्य | The
                activity has the following expected residual hazards (Tick the
                relevant items):&nbsp;
                <span style={boxStyle}>
                  Lack of Oxygen/H₂S
                  {parsedHazards.includes("Lack of Oxygen/H₂S") && (
                    <span style={tickStyle}>✓</span>
                  )}
                </span>
                &nbsp;
                <span style={boxStyle}>
                  Toxic Gases
                  {parsedHazards.includes("Toxic Gases") && (
                    <span style={tickStyle}>✓</span>
                  )}
                </span>
                &nbsp;
                <span style={boxStyle}>
                  Combustible Cases
                  {parsedHazards.includes("Combustible Cases") && (
                    <span style={tickStyle}>✓</span>
                  )}
                </span>
                &nbsp;
                <span style={boxStyle}>
                  Pyrophoric Iron
                  {parsedHazards.includes("Pyrophoric Iron") && (
                    <span style={tickStyle}>✓</span>
                  )}
                </span>
                &nbsp;
                <span style={boxStyle}>
                  Corrosive Chemicals
                  {parsedHazards.includes("Corrosive Chemicals") && (
                    <span style={tickStyle}>✓</span>
                  )}
                </span>
                &nbsp;
                <span style={boxStyle}>
                  Steam-Condensable
                  {parsedHazards.includes("Steam-Condensable") && (
                    <span style={tickStyle}>✓</span>
                  )}
                </span>
                &nbsp;
                <span style={boxStyle}>
                  Others
                  {parsedHazards.includes("Others") && (
                    <span style={tickStyle}>✓</span>
                  )}
                </span>
              </div>

              {/* PPE */}
              <div>
                2.पीपीई मानकों के अतिरिक्त वैधानिक संरक्षणात्मक उपकरण प्रयोग
                किया जाए (हेल्मेट, सुरक्षा: जूते, हाथों के दस्ताने, बायलेर सूट)
                फेस शील्ड / एप्रन/ डस्ट रेस्पिरेटर/ फ्रेश एयर मास्क/ लाइफलाइन /
                सेफ्टी बेल्ट / एयरलाइन/ इयर मफ इत्यादि | Following PPE to be
                used in addition to standards PPEs (Helmet, Safety Shoes, Hand
                gloves, Boiler suit):&nbsp;
                <span style={boxStyle}>
                  Face Shield
                  {parsedPPE.includes("Face Shield") && (
                    <span style={tickStyle}>✓</span>
                  )}
                </span>
                &nbsp;
                <span style={boxStyle}>
                  Apron
                  {parsedPPE.includes("Apron") && (
                    <span style={tickStyle}>✓</span>
                  )}
                </span>
                &nbsp;
                <span style={boxStyle}>
                  Dust Respirator
                  {parsedPPE.includes("Dust Respirator") && (
                    <span style={tickStyle}>✓</span>
                  )}
                </span>
                &nbsp;
                <span style={boxStyle}>
                  Life Line
                  {parsedPPE.includes("Life Line") && (
                    <span style={tickStyle}>✓</span>
                  )}
                </span>
                &nbsp;
                <span style={boxStyle}>
                  Goggles
                  {parsedPPE.includes("Goggles") && (
                    <span style={tickStyle}>✓</span>
                  )}
                </span>
                &nbsp;
                <span style={boxStyle}>
                  Fresh Air Mask
                  {parsedPPE.includes("Fresh Air Mask") && (
                    <span style={tickStyle}>✓</span>
                  )}
                </span>
                &nbsp;
                <span style={boxStyle}>
                  Safety Belt (Full body harness)
                  {parsedPPE.includes("Safety Belt (Full body harness)") && (
                    <span style={tickStyle}>✓</span>
                  )}
                </span>
                &nbsp;
                <span style={boxStyle}>
                  Airline
                  {parsedPPE.includes("Airline") && (
                    <span style={tickStyle}>✓</span>
                  )}
                </span>
                &nbsp;
                <span style={boxStyle}>
                  Earmuff
                  {parsedPPE.includes("Earmuff") && (
                    <span style={tickStyle}>✓</span>
                  )}
                </span>
              </div>

              {/* Additional Precaution */}
              <br />
              <div>
                3. अन्य कोई सावधानी, यदि कोई है। /Additional precaution, if any:
                <span className="work-text">
                  {hazardsPrecautions.length > 0
                    ? hazardsPrecautions[0].precaution_description ||
                      "................."
                    : "................."}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Template5;

// const Template5 = ({ hazardsPrecautions }) => {
//   console.log("hazardsPrecautions", hazardsPrecautions)
//   const boxStyle = {
//     border: "1px solid #ccc",
//     padding: "2px 6px",
//     display: "inline-block",
//     borderRadius: "4px",
//     marginRight: "4px",
//     fontSize: "0.9em",
//   };

//   const tickStyle = {
//     color: "green",
//     fontWeight: "bold",
//     marginLeft: "4px",
//   };
//   return (
//     <>
//       <div className="template-container">
//         <div className="template-container-content1">
//           <div className="template-container-pera">
//             <div className="cold-remark">
//               <div className="template-heading">टिप्पणियाँ / Remarks:</div>
//               <div>
//                 1.क्रिया में निम्नलिखित संभावित जोखिम हो सकते है (संभावित
//                 मुद्दों को चिह्नित करें) ऑक्सीजन की कमी एवं ज्वलनशील पदार्थ,
//                 पायरोफोरिक आयर्न संक्षारक रसायन पाया, संभावित अन्य | The
//                 activity has the following expected residual hazards (Tick the
//                 relevant items):&nbsp;
//                 <span style={boxStyle}>
//                   lack of Oxygen/H₂S <span style={tickStyle}>✓</span>
//                 </span>
//                 &nbsp;
//                 <span style={boxStyle}>Toxic Gases</span>&nbsp;
//                 <span style={boxStyle}>
//                   Combustible Cases/Pyrophoric Iron{" "}
//                   <span style={tickStyle}>✓</span>
//                 </span>
//                 &nbsp;
//                 <span style={boxStyle}>Corrosive Chemicals</span>&nbsp;
//                 <span style={boxStyle}>Steam-Condensable</span>&nbsp;
//                 <span style={boxStyle}>others</span>
//               </div>

//               <div>
//                 2.पीपीई मानकों के अतिरिक्त वैधानिक संरक्षणात्मक उपकरण प्रयोग
//                 किया जाए (हेल्मेट, सुरक्षा: जूते, हाथों के दस्ताने, बायलेर सूट)
//                 फेस शील्ड / एप्रन/ डस्ट रेस्पिरेटर/ फ्रेश एयर मास्क/ लाइफलाइन /
//                 सेफ्टी बेल्ट / एयरलाइन/ इयर मफ इत्यादि | Following PPE to be
//                 used in addition to standards PPEs (Helmet, Safety Shoes, Hand
//                 gloves, Boiler suit):&nbsp;
//                 <span style={boxStyle}>
//                   Face shield/Apron <span style={tickStyle}>✓</span>
//                 </span>
//                 &nbsp;
//                 <span style={boxStyle}>Goggles</span>&nbsp;
//                 <span style={boxStyle}>Dust Respirator</span>&nbsp;
//                 <span style={boxStyle}>Fresh Air mask</span>&nbsp;
//                 <span style={boxStyle}>Life line</span>&nbsp;
//                 <span style={boxStyle}>Safety belt (Full body harness)</span>
//                 &nbsp;
//                 <span style={boxStyle}>Airline</span>&nbsp;
//                 <span style={boxStyle}>Earmuff</span>
//               </div>

//               <br />
//               <div>
//                 3. अन्य कोई सावधानी, यदि कोई है। /Additional precaution, if any:
//                 <span className="work-text">
//                   {hazardsPrecautions.length > 0
//                     ? hazardsPrecautions
//                         .map(
//                           (item) =>
//                             item.precaution_description || "................."
//                         )
//                         .join(", ")
//                     : "................."}
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Template5;

{
  /* <div>
                1.क्रिया में निम्नलिखित संभावित जोखिम हो सकते है (संभावित
                मुद्दों को चिह्नित करें) ऑक्सीजन की कमी एवं ज्वलनशील पदार्थ,
                पायरोफोरिक आयर्न संक्षारक रसायन पाया, संभावित अन्य | The
                activity has the following expected residual hazards (Tick the
                relevant items): lack of Oxygen/H₂S, Toxic Gases, Combustible
                Cases/Pyrophoric Iron/Corrosive
                Chemicals/Steam-Condensable/others.
              </div>
              <div>
                2.पीपीई मानकों के अतिरिक्त वैधानिक संरक्षणात्मक उपकरण प्रयोग
                किया जाए (हेल्मेट, सुरक्षा: जूते, हाथों के दस्ताने, बायलेर सूट)
                फेस शील्ड / एप्रन/ डस्ट रेस्पिरेटर/ फ्रेश एयर मास्क/ लाइफलाइन /
                सेफ्टी बेल्ट / एयरलाइन/ इयर मफ इत्यादि | Following PPE to be
                used in addition to standards PPEs (Helmet, Safety Shoes, Hand
                gloves, Boiler suit) Face shield/Apron/ Goggles/Dust Respirator/
                Fresh Air mask/Life line/Safety belt (Full body
                harness)/Airline/Earmuff etc.
              </div>{" "} */
}
